//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubscribeEmail from '~/mixins/subscribe/email'
import { SAMPLE_REPORT_LIST_ID } from '~/constants/klaviyo'

export default {
  mixins: [
    SubscribeEmail
  ],
  data () {
    return {
      listID: SAMPLE_REPORT_LIST_ID,
      email: null,
      alertVariant: 'success',
      alertTime: 0,
      alertText: ''
    }
  },
  methods: {
    trackEmailSubscribed () {
      this.addDDAction('Email subscribed sample report', {
        path: this.$route.path,
        email: this.email,
        listID: this.listID,
        section: 'sampleReport'
      })
    },
    async submitForm () {
      const result = await this.subscribeEmail({ email: this.email, listID: this.listID })
      this.alertTime = 5
      if (!result) {
        this.alertText = this.$t('home.sampleReport.alert.error')
        this.alertVariant = 'danger'
        return
      }
      this.alertText = this.$t('home.sampleReport.alert.success')
      this.trackEmailSubscribed()
    }
  }
}
